import { Component, AfterViewInit } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { DashboardAccessPermissions } from '../dashboard-access.model';
import { CxRoleModel } from 'src/app/reusables/assign-tool/angular-assign-tool/angular-assign-tool.models';

@Component({
    selector: 'cv-role-selector-cell-renderer',
    templateUrl: './role-selector-cell-renderer.component.html',
    styleUrls: ['./role-selector-cell-renderer.component.scss'],
})
export class RoleSelectorCellRendererComponent implements AfterViewInit {
    public params;

    public owner = DashboardAccessPermissions.WriteTheirs;
    public ownerLabel: string;
    public viewOnlyLabel: string;
    public view = DashboardAccessPermissions.ReadTheirs;
    public roles: CxRoleModel[] = [];
    public options = [{ value: 'roleA' },
                      { value: 'roleB' }];
    public checkedRoles: CxRoleModel[] = [];

    constructor(
    ) { }

    ngAfterViewInit(): void {
    }

    async agInit(params) {
        this.params = params;
        this.roles = this.params.roles;

        
        // Select all roles by default if none are selected
        if (!this.params.data.roleUUIDs || this.params.data.roleUUIDs.length === 0) {
            this.params.data.roleUUIDs = this.roles.map(role => role.RoleId);
        }

        this.checkedRoles = this.roles.filter(role => this.params.data.roleUUIDs.includes(role.RoleId));
    }

    onValueChange(options) {
         this.params.data.roleUUIDs = options.map(option => option.RoleId);
        //future PR will add logic here to update access changes
    }

    onDropdownOpenStateChange(isOpen: boolean) {
        if (!isOpen) {
            //on close check if 0 items are selected, if so select all
            if (this.params.data.roleUUIDs.length === 0) {
                this.params.data.roleUUIDs = this.roles.map(role => role.RoleId);
                this.checkedRoles = this.roles.filter(role => this.params.data.roleUUIDs.includes(role.RoleId));
                //future PR will add logic here to update access changes
            }
        }
    }
}
